export default __webpack_public_path__ + "static/media/yamm-screenshot.0e8a6974.png";